<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <div class="">
      <div @keyup.enter.stop="getPage({pageNum: 1})">
        <el-select v-model="queryParam.specialtyId" placeholder="所属专业" @change="getLevel" filterable clearable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in specialtyList" :key="index" :label="item.specialtyName" :value="item.specialtyId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.gradeId" placeholder="级别" @change="getPage({pageNum: 1})" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in gradeList" :key="index" :label="item.gradeName" :value="item.gradeId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select disabled v-model="queryParam.userId" placeholder="评委老师" @change="getPage({pageNum: 1})" filterable style="width: 200px;margin-right:10px;">
          <el-option v-for="item in teacherList" :key="item.userId" :label="item.username" :value="item.userId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.evaluateStatus" placeholder="评审状态" filterable style="width: 200px;margin-right:10px;">
          <el-option v-for="(item,index) in Tool.map2arr($enums.evaluateStatus2)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <!--        <el-select v-model="queryParam.specialtyId" placeholder="综合成绩" @change="getPage({pageNum: 1})" filterable clearable style="width:200px;margin-right:10px;margin-bottom: 10px;">-->
        <!--          <el-option v-for="(item,index) in specialtyList" :key="index" :label="item.specialtyName" :value="item.specialtyId" :class="item.disabled?'none':''"></el-option>-->
        <!--        </el-select>-->
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.examineeName" clearable placeholder="姓名"></el-input>
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.examineeIdNo" clearable placeholder="证件号"></el-input>
        <el-button @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
        <el-button @click="queryParam=JSON.parse(JSON.stringify(oldQueryParam)),getSpecialtyList(),gradeList=[]" type="default">重置</el-button>
      </div>
    </div>
    <div ref="page" style="margin-top: 12px;">
      <el-table :data="page.list" stripe :height="tableHeight" size="medium">
        <el-table-column prop="examineeName" label="姓名">
          <!--          <template slot-scope="scope">-->
          <!--            <span v-show="!scope.row.trueEye2">-->
          <!--              <span>-->
          <!--                    {{scope.row.examineeName}}-->
          <!--              </span>-->
          <!--              <i v-if="scope.row.examineeName" style="margin-left: 5px;" class="el-icon-view" @click="reloadName(scope.$index, scope.row)"></i>-->
          <!--            </span>-->
          <!--            <span v-show="scope.row.trueEye2">-->
          <!--              <span>-->
          <!--                    {{scope.row.examineeName2}}-->
          <!--              </span>-->
          <!--              <i v-if="scope.row.examineeName2" style="margin-left: 5px;" class="el-icon-view" @click="reloadName(scope.$index, scope.row)"></i>-->
          <!--            </span>-->
          <!--          </template>-->
        </el-table-column>
        <el-table-column prop="agentName" label="考级点"></el-table-column>
        <el-table-column prop="categoryName" label="所属分类"></el-table-column>
        <el-table-column prop="specialtyName" label="所属专业">
          <template slot-scope="scope">
            {{scope.row.specialtyName}}-{{scope.row.gradeName}}
          </template>
        </el-table-column>
        <el-table-column prop="examineeIdNo" label="证件号码">
          <!--          <template slot-scope="scope">-->
          <!--            <span v-show="!scope.row.trueEye">-->
          <!--              <span>{{scope.row.examineeIdNo}}</span>-->
          <!--              <i v-if="scope.row.examineeIdNo" style="margin-left: 5px;" class="el-icon-view" @click="reloadIdNo(scope.$index, scope.row)"></i>-->
          <!--            </span>-->
          <!--            <span v-show="scope.row.trueEye">-->
          <!--              <span>{{scope.row.examineeIdNo2}}</span>-->
          <!--              <i v-if="scope.row.examineeIdNo2" style="margin-left: 5px;" class="el-icon-view" @click="reloadIdNo(scope.$index, scope.row)"></i>-->
          <!--            </span>-->
          <!--          </template>-->
        </el-table-column>
        <el-table-column prop="mainTeacherNames" label="评委老师"></el-table-column>
        <el-table-column prop="evaluateStatus" label="评审状态">
          <template slot-scope="scope">
            {{$enums.evaluateStatus2[scope.row.evaluateStatus]}}
          </template>
        </el-table-column>
        <el-table-column prop="evaluateResult" label="综合成绩"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间">
          <template slot-scope="scope">
            <span v-if="scope.row.updateTime">{{$moment(scope.row.updateTime).format('YYYY-MM-DD HH:mm')}}</span>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'admin-detail',
  components: {},
  props: [],
  data () {
    return {
      tableHeight: 200,
      queryParam: { batchId: this.$route.query.batchId, specialtyId: this.$route.query.specialtyId, userId: this.$route.query.teacherId },
      page: { pageSize: 20, pageNum: 1 },
      specialtyList: [],
      teacherList: [],
      oldQueryParam: {},
      gradeList: []
    }
  },
  async created () {
    await this.getSpecialtyList()
    this.teacherList = await this.$HTTP.ApiUser.getTeacherList(this.queryParam)
    this.oldQueryParam = JSON.parse(JSON.stringify(this.queryParam))
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
    })
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async getLevel (event) {
      if (event) {
        this.queryParam.gradeId = ''
      }
      this.gradeList = await this.$HTTP.ApiSpecialty.getGradeList({ specialtyId: this.queryParam.specialtyId, status: 2 })
      await this.getPage()
    },
    async getSpecialtyList (event) {
      this.specialtyList = await this.$HTTP.ApiSpecialty.getList({ batchId: this.$route.query.batchId })
      if (event) {
        this.queryParam.specialtyId = ''
        this.queryParam.gradeId = ''
        this.gradeList = []
      }
      await this.getPage()
    },
    async getPage (queryParam) {
      try {
        this.queryParam.teacherId = this.queryParam.userId
        // this.queryParam = Object.assign({}, this.queryParam, queryParam)
        let newQueryParam = JSON.parse(JSON.stringify(this.queryParam))
        if (newQueryParam.evaluateStatus || newQueryParam.evaluateStatus === 0) {
          newQueryParam.evaluateStatus = [newQueryParam.evaluateStatus]
        }
        newQueryParam = Object.assign({}, newQueryParam, queryParam)
        let page = await this.$HTTP.ApiCommon.getAchievementPage(newQueryParam)
        // if (page.list) {
        //   page.list.map(el => {
        //     this.$set(el, 'examineeIdNo2', el.examineeIdNo)
        //     this.$set(el, 'examineeName2', el.examineeName)
        //     this.$set(el, 'trueEye2', true)
        //     this.$set(el, 'trueEye', true)
        //     if (el.examineeIdNo) {
        //       el.examineeIdNo2 = el.examineeIdNo.replace(/^(.{6})(?:\w+)/, '\$1********')
        //     }
        //     if (el.examineeName) {
        //       el.examineeName2 = el.examineeName.replace(/(?<=.)./g, '*')
        //     }
        //   })
        // }
        this.page = page
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    }
    // async reloadIdNo (index, row) {
    //   if (row.trueEye === true) {
    //     this.$set(row, 'trueEye', false)
    //   } else {
    //     this.$set(row, 'trueEye', true)
    //   }
    // },
    // async reloadName (index, row) {
    //   if (row.trueEye2 === true) {
    //     this.$set(row, 'trueEye2', false)
    //   } else {
    //     this.$set(row, 'trueEye2', true)
    //   }
    // }
  }
}
</script>
